<template>
    <div class="amazon-certification-page">

        <el-tabs v-model="tableType" @tab-click="handleSelectChange">
            <el-tab-pane label="题库" name="tk"></el-tab-pane>
            <el-tab-pane label="真实问答" name="zswd"></el-tab-pane>
        </el-tabs>
        <!-- 查询区域 -->
        <div class="select-box">
            <div class="select-item">
                <div class="select-label">编号</div>
                <el-input v-model="searchForm.personNo"></el-input>
            </div>
            <el-button type="primary" @click="handleSearch">
                查询
            </el-button>

            <el-button @click="handleReset">
                重置
            </el-button>

            <el-button type="primary" @click="handleImportQuestion">
                导入题库
            </el-button>

            <el-button type="primary" @click="handleImportQa">
                导入真实问答
            </el-button>
        </div>


        <el-table v-loading="listLoading" key="aaa" v-if="tableType == 'tk'" :data="personNoList" border fit style="width: 100%" height="720">
            <el-table-column label="编号" prop="personNo" width="100" align="center" />
            <el-table-column label="是否通过" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.passed === 1 ? 'success' : 'info'">
                        {{ scope.row.passed === 1 ? '已通过' : '未通过' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.passed === 0" @click="passRow(scope.row)">通过</el-button>
                    <el-button @click="getDetail(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <template v-else>
            <el-table v-loading="zswdLoading" key="bbb" height="680" :data="zswdList" border stripe style="width:100%;">
                <el-table-column prop="personNo" label="人员编号" width="120" align="center"></el-table-column>
                <el-table-column prop="questionOrder" label="顺序" width="80" align="center"></el-table-column>
                <el-table-column prop="question" label="问题" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="answer" label="答案" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
            </el-table>

            <div style="text-align:center;margin-top:15px;">
                <el-pagination :current-page="pageNum" :page-size="pageSize"
                    :page-sizes="[10, 20, 50, 100]" :total="zswdTotal" layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleZswdSizeChange" @current-change="handleZswdCurrentChange">
                </el-pagination>
            </div>
        </template>

        <el-dialog :visible.sync="listDialogVisible" top="8vh" width="80%">
            <el-table v-if="tableType == 'tk'" :data="list" border fit
                style="width: 100%" height="600">
                <el-table-column label="编号" prop="personNo" width="100" align="center" />
                <el-table-column label="分类" prop="category" width="180" />
                <el-table-column label="问题" prop="question" min-width="300" />
                <el-table-column label="参考答案" prop="referenceAnswer" min-width="300" />
                <el-table-column label="顺序" prop="questionOrder" width="80" align="center" />
            </el-table>
        </el-dialog>


        <el-dialog :title="importType === 'question' ? '导入题库' : '导入真实问答'" :visible.sync="personDialogVisible"
            width="500px" :close-on-click-modal="false" @closed="resetPersonDialog">
            <el-form ref="personForm" :model="personForm" label-width="100px">
                <el-form-item label="人员编号">
                    <el-input v-model="personForm.personNo" placeholder="请输入 person_no" maxlength="50" clearable />
                </el-form-item>

                <el-form-item label="Excel文件" v-if="importType === 'question'">
                    <el-upload ref="upload" action="" :auto-upload="false" :show-file-list="true" :limit="1"
                        accept=".xlsx,.xls" :on-change="handleFileChange" :on-remove="handleFileRemove"
                        :before-upload="beforeFileUpload">
                        <el-button type="primary" icon="el-icon-upload2">
                            选择Excel文件
                        </el-button>

                        <div slot="tip" class="el-upload__tip">
                            只能上传 xls、xlsx 文件
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="对话内容" v-else>
                    <el-input type="textarea" v-model="importText"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button @click="personDialogVisible = false">
                    取消
                </el-button>

                <el-button type="primary" :loading="importLoading" @click="confirmImport">
                    导入
                </el-button>
            </span>
        </el-dialog>

        <!-- ============================== -->
        <!-- 真实问答 -->
        <!-- ============================== -->

        <el-dialog title="真实认证问答记录" :visible.sync="qaDialogVisible" width="900px" :close-on-click-modal="false">

            <div v-if="currentQaList.length > 0" class="qa-list">

                <div v-for="item in currentQaList" :key="item.id" class="qa-item">

                    <div class="qa-order">
                        第 {{ item.questionOrder }} 问
                    </div>

                    <div class="qa-question">

                        <span class="qa-label">
                            问：
                        </span>

                        {{ item.question }}

                    </div>

                    <div class="qa-answer">

                        <span class="qa-label">
                            答：
                        </span>

                        {{ item.answer || '暂无回答' }}

                    </div>

                </div>

            </div>

            <el-empty v-else description="暂无真实问答记录" />

            <span slot="footer">

                <el-button @click="qaDialogVisible = false">
                    关闭
                </el-button>

            </span>

        </el-dialog>

    </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import { ajaxPost, Baseurl } from "@/api/api/api";
import { ajaxGet } from '../../api/api/api';

export default {
    name: 'AmazonCertification',
    data() {
        return {
            searchForm: {
                personNo: ''
            },
            importText: '',

            currentPersonNo: '',

            questionList: [],

            listDialogVisible: false,
            currentPassed: false,

            loading: false,

            statusLoading: false,

            // ==========================
            // Excel
            // ==========================

            importLoading: false,

            // ==========================
            // 真实问答
            // ==========================

            qaDialogVisible: false,

            currentQaList: [],
            listLoading: false,

            list: [],

            listQuery: {
                personNo: ''
            },

            personDialogVisible: false,

            importType: '',

            personForm: {
                personNo: '',
                file: null
            },
            personNoList: [],
            tableType: 'tk', //tk：题库，zswd：真实问答
            pageNum: 1,
            pageSize: 20,
            zswdLoading: false,
            zswdList: [],
            zswdTotal: 0
        }

    },
    created(){
        this.getCertificationList();
    },

    methods: {
        getCertificationList(){
            ajaxGet(Baseurl + "amazonCertificationController/getCertificationList").then((res) => {
                if(res.data.code == 200){
                    this.personNoList = res.data.data;
                }
                if(this.personNoList.length == 0){
                    this.$message.warning("暂无数据请添加")
                }
            })
        },
        handleSelectChange(){
            this.list = [];
            if(this.tableType == 'tk'){
                this.handleSearch();
            }else{
                this.handleZswdSearch();
            }
        },
        handleFileChange(file, fileList) {
            this.personForm.file = file.raw
        },

        handleFileRemove() {
            this.personForm.file = null
        },

        confirmImport() {
            if (!this.personForm.personNo ||
                !this.personForm.personNo.trim()) {
                this.$message.warning('请输入人员编号')
                return
            }

            

            // importType === 'question' ? '导入题库' : '导入真实问答'
            const personNo = this.personForm.personNo.trim()
            const file = this.personForm.file
            if(this.importType === 'question'){ // 导入题库
                if (!this.personForm.file) {
                    this.$message.warning('请选择Excel文件')
                    return
                }
                this.parseExcel(file, (rows) => {
                    this.parseQuestionExcel(personNo, rows)
                })
            }else{ // 导入真实问答
                this.importLoading = true
                if(!this.importText){
                    this.$message.warning('请填入对话内容')
                    return
                }
                ajaxPost(
                    Baseurl + 'amazonRealQaController/importText',
                    {
                        personNo: personNo,
                        text: this.importText
                    }
                ).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('题库导入成功')
                        this.personDialogVisible = false
                        this.handleSearch()
                    } else {
                        this.$message.error(
                            res.data.message || '题库导入失败'
                        )
                    }
                }).catch(() => {
                    this.$message.error('题库导入失败')
                }).finally(() => {
                    this.importLoading = false
                })
            }
        },
        getDetail(item){
            const url = Baseurl + "amazonCertificationController/getDetail"
            this.list = [];
            ajaxGet(url + "?personNo=" + item.personNo).then((res) => {
                if (res.data.code == 200) {
                    this.listDialogVisible = true;
                    this.list = res.data.data;
                }
            })
        },
        passRow(item){
            const url = Baseurl + "amazonCertificationController/pass?id=" + item.id;
            this.list = [];
            ajaxGet(url).then((res) => {
                if (res.data.code == 200) {
                    this.$message.success("操作成功");
                    this.handleSearch();
                }
            })
        },
        resetPersonDialog() {
            this.personForm.personNo = ''
            this.personForm.file = null
            this.importType = ''

            if (this.$refs.upload) {
                this.$refs.upload.clearFiles()
            }
        },
        parseQuestionExcel(personNo, rows) {
            const list = []
            let currentCategory = ''
            let questionOrder = 1

            for (let i = 0; i < rows.length; i++) {
                const row = rows[i]

                const question = row[0]
                    ? String(row[0]).trim()
                    : ''

                const answer = row[1]
                    ? String(row[1]).trim()
                    : ''

                // 两列都为空，停止
                if (!question && !answer) {
                    break
                }

                // 第一列有值，第二列没有值 = 分类
                if (question && !answer) {
                    currentCategory = question
                    continue
                }

                // 正常问题
                if (question) {
                    list.push({
                        personNo: personNo,
                        category: currentCategory,
                        question: question,
                        referenceAnswer: answer,
                        questionOrder: questionOrder++
                    })
                }
            }

            if (!list.length) {
                this.$message.warning('Excel中没有有效的题库数据')
                return
            }

            this.submitQuestionImport(personNo, list)
        },
        // 真实问答search
        handleZswdSearch(){
            this.pageNum = 1;
            this.getZswdList();
        },
        getZswdList() {
            this.zswdLoading = true;
            ajaxPost(Baseurl + "amazonRealQaController/getList", {
                personNo: this.searchForm.personNo,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then((res) => {
                if (res.data.code == 200) {
                    this.zswdList = res.data.data.list || [];
                    this.zswdTotal = res.data.data.total || 0;
                } else {
                    this.$message.error(res.data.msg || "查询失败");
                }
            }).finally(() => {
                this.zswdLoading = false;
            });
        },
        handleZswdSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1;
            this.getZswdList();
        },
        handleZswdCurrentChange(val) {
            this.pageNum = val;
            this.getZswdList();
        },

        parseQaExcel(personNo, rows) {
            const list = []
            let questionOrder = 1

            for (let i = 0; i < rows.length; i++) {
                const row = rows[i]

                const question = row[0]
                    ? String(row[0]).trim()
                    : ''

                const answer = row[1]
                    ? String(row[1]).trim()
                    : ''

                // 两列都为空，停止
                if (!question && !answer) {
                    break
                }

                if (!question) {
                    continue
                }

                list.push({
                    personNo: personNo,
                    question: question,
                    answer: answer,
                    questionOrder: questionOrder++
                })
            }

            if (!list.length) {
                this.$message.warning('Excel中没有有效的真实问答数据')
                return
            }

            this.submitQaImport(personNo, list)
        },
        parseExcel(file, callback) {
            const reader = new FileReader()

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result)

                    const workbook = XLSX.read(data, {
                        type: 'array'
                    })

                    const sheetName = workbook.SheetNames[0]
                    const worksheet = workbook.Sheets[sheetName]

                    const rows = XLSX.utils.sheet_to_json(
                        worksheet,
                        {
                            header: 1,
                            defval: ''
                        }
                    )

                    callback(rows)
                } catch (e) {
                    console.error(e)
                    this.$message.error('Excel解析失败')
                }
            }

            reader.readAsArrayBuffer(file)
        },
        submitQuestionImport(personNo, list) {
            this.importLoading = true

            ajaxPost(
                Baseurl + 'amazonCertificationController/importQuestion',
                {
                    personNo: personNo,
                    list: list
                }
            ).then(res => {
                if (res.data.code === 200) {
                    this.$message.success('题库导入成功')
                    this.personDialogVisible = false
                    this.handleSearch()
                } else {
                    this.$message.error(
                        res.data.message || '题库导入失败'
                    )
                }
            }).catch(() => {
                this.$message.error('题库导入失败')
            }).finally(() => {
                this.importLoading = false
            })
        },
        submitQaImport(personNo, list) {
            this.importLoading = true

            ajaxPost(
                '/api/admin/amazon/qa/import',
                {
                    personNo: personNo,
                    list: list
                }
            ).then(res => {
                if (res.data.code === 200) {
                    this.$message.success('真实问答导入成功')
                    this.personDialogVisible = false
                } else {
                    this.$message.error(
                        res.data.message || '真实问答导入失败'
                    )
                }
            }).catch(() => {
                this.$message.error('真实问答导入失败')
            }).finally(() => {
                this.importLoading = false
            })
        },
        beforeFileUpload(file) {
            const isExcel =
                file.name.endsWith('.xls') ||
                file.name.endsWith('.xlsx')

            if (!isExcel) {
                this.$message.error('只能上传xls或xlsx文件')
                return false
            }

            return true
        },
        handleImportQuestion() {
            this.importType = 'question'
            this.personDialogVisible = true
        },

        handleImportQa() {
            this.importType = 'qa'
            this.personDialogVisible = true
        },
        async handleSearch() {
            this.personNoList = [];
            this.list = [];
            if (this.tableType === 'tk') {
                let url = Baseurl + "amazonCertificationController/getCertificationList";
                if(this.searchForm.personNo){
                    url = Baseurl + "amazonCertificationController/getCertificationList?personNo=" + this.searchForm.personNo
                }
                ajaxGet(url).then((res) => {
                    if (res.data.code == 200) {
                        this.personNoList = res.data.data;
                    }
                    if (this.personNoList.length == 0) {
                        this.$message.warning("没有查到数据")
                    }
                })
            }else{
                this.handleZswdSearch();
            }
            
        },

        // =====================================================
        // 重置
        // =====================================================

        handleReset() {

            this.searchForm.personNo = ''

            this.handleSearch()

        },
    }
}
</script>

<style scoped lang="scss">
.amazon-certification-page {
    .select-box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 10px;

        .select-item {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .select-label {
                margin-right: 10px;
                white-space: nowrap;
            }
        }

        .el-button {
            margin: 0;
            margin-right: 10px;
        }

    }
}

.search-card,
.info-card,
.table-card {
    margin-bottom: 15px;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 600;
}

.header-tip {
    color: #909399;
    font-size: 13px;
    font-weight: normal;
}

.person-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.info-item {
    display: flex;
    align-items: center;
    margin-right: 40px;
    margin-bottom: 5px;
}

.info-label {
    color: #909399;
    margin-right: 8px;
}

.info-value {
    color: #303133;
    font-weight: 600;
}

.status-action {
    margin-left: auto;
    margin-right: 0;
}

.qa-list {
    max-height: 600px;
    overflow-y: auto;
}

.qa-item {
    padding: 18px 20px;
    margin-bottom: 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
}

.qa-order {
    margin-bottom: 12px;
    color: #409eff;
    font-size: 14px;
    font-weight: 600;
}

.qa-question,
.qa-answer {
    line-height: 1.8;
    font-size: 14px;
}

.qa-answer {
    margin-top: 8px;
    color: #606266;
}

.qa-label {
    display: inline-block;
    width: 35px;
    color: #303133;
    font-weight: 600;
}

/*
 * Element UI 的 el-upload
 * 默认是块级元素，这里让它和按钮保持在同一行
 */
.search-card .el-upload {
    display: inline-block;
}
</style>